var map = {
	"./action_image.png": 404,
	"./dimond.png": 405,
	"./logo_01.png": 58,
	"./logo_02.png": 161,
	"./logo_03.png": 162,
	"./logo_04.png": 59,
	"./logo_05.png": 60,
	"./p_feature1.png": 406,
	"./prototype_banner_img.png": 407,
	"./prototype_banner_img2.png": 408,
	"./psd.png": 409,
	"./saas.png": 410,
	"./tab.png": 411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 580;